import get from "lodash/get";

export default {
  activeProductId(state) {
    return state.activeContentProductId || get(state, "setup.product_id");
  },
  isPortal(state) {
    return get(state, "setup.kind") === "portal";
  },
  homeRoute(state) {
    if (!state.activeContentProductId) return { name: "home" };

    return {
      name: "content-home",
      params: { contentProductId: String(state.activeContentProductId) }
    };
  }
};
